import React from "react";
import { useNavigate } from "react-router-dom";

interface AnnouncementNewsProps {
    data: any;
    isLoading: boolean;
}

const AnnouncementNewsCard: React.FC<AnnouncementNewsProps> = (props) => {

    const navigate = useNavigate();

    const handleClick = (e: any) => {
        e.stopPropagation()

        const records = props.data;

        if (records) {
            const firstRecordId = records._id;
            navigate(`/haberler-duyurular-detay/${firstRecordId}`, { state: { data: records[0] } });
        } else {
            console.error("No records found in data.");
        }

    };

    return (
        <div className="col-sm-10 col-sm-push-1">
            <div className="side-item event-item content-padding bottommargin_30">
                <div className="row">
                    <div className="col-md-6">
                        <div className="item-media" style={{ width: "450px", height: "300px", overflow: "hidden", display: "flex" }}>
                            <img src={props.data?.resim} style={{ objectFit: "contain", height: "100%", width: "100%" }} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="item-content">

                            <h3 className="entry-title topmargin_0">
                                {props.data?.title}
                            </h3>
                            <p className="item-meta greylinks">
                                {/* __meta__created_at */}
                                <i className="rt-icon2-calendar4 highlight" /> {props.data?.tarih}
                            </p>
                            <p dangerouslySetInnerHTML={{ __html: props.data?.content.slice(0, 50) }}></p>
                            <button className="theme_button color2"
                                onClick={(e) => {
                                    handleClick(e)
                                }}> Devamını Oku</button>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default AnnouncementNewsCard;